import {useTheme} from "@mui/material/styles";
import {Box, Drawer, IconButton, useMediaQuery} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export enum DrawerCloseButton {
    CLOSE,
    BACK
}

export type SideDrawerProps = {
    onDrawerClosed: (isViaCloseButton: boolean) => void;
    closeButton?: DrawerCloseButton;
    backdropInvisible?: boolean;
};

function withDrawer<TProps extends SideDrawerProps>(Component: React.ComponentType<TProps>) {

    return (props : TProps) => {

        const theme = useTheme();
        const isMdScreen = useMediaQuery(theme.breakpoints.up("md"));

        return (
            <Drawer
                open={true}
                onClose={() => props.onDrawerClosed(false)}
                anchor={isMdScreen ? "right" : "bottom"}
                PaperProps={{ sx: isMdScreen ? { width: 360 } : {} }}
                slotProps={{
                    backdrop: {
                        invisible: props.backdropInvisible ?? false,
                    },
                }}
            >
                <IconButton
                    onClick={() => props.onDrawerClosed(true)}
                    size={"small"}
                    sx={{
                        position: "absolute",
                        top: 1,
                        left: 8,
                        zIndex: 1,
                    }}
                >
                    {props.closeButton === DrawerCloseButton.BACK ? <ArrowBackIcon /> : <CloseIcon/>}
                </IconButton>
                <Box sx={{ px: 1, mt: 1 }}>
                    <Component {...props} />
                </Box>
            </Drawer>
        );
    };
}

export default withDrawer;